if (!customElements.get("cart-toolbar")) {
  customElements.define(
    "cart-toolbar",
    class CartToolbar extends HTMLElement {
      constructor() {
        super();
        this.activeSection = null;
        this.triggers = [];
        this.notePanel = null;
        this.couponPanel = null;
        this.shippingPanel = null;
        this.noteWrap = null;
        this.couponWrap = null;
        this.shippingWrap = null;
        this.shippingButton = null;
        this.expand = null;
        this.cancelButtons = [];
        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
      }

      connectedCallback() {
        this.triggers = Array.from(
          this.querySelectorAll("[data-toolbar-trigger]"),
        );
        this.notePanel = this.querySelector(".cart-drawer-toolbar__note-panel");
        this.couponPanel = this.querySelector(
          ".cart-drawer-toolbar__coupon-panel",
        );
        this.shippingPanel = this.querySelector(
          ".cart-drawer-toolbar__shipping-panel",
        );
        this.noteLabel = this.querySelector(
          ".cart-drawer-toolbar__note .cart-drawer-toolbar__label",
        );
        this.couponLabel = this.querySelector(
          ".cart-drawer-toolbar__coupon .cart-drawer-toolbar__label",
        );
        this.shippingLabel = this.querySelector(
          ".cart-drawer-toolbar__shipping .cart-drawer-toolbar__label",
        );
        this.noteWrap = this.querySelector(".cart-drawer-toolbar__note");
        this.couponWrap = this.querySelector(".cart-drawer-toolbar__coupon");
        this.shippingWrap = this.querySelector(
          ".cart-drawer-toolbar__shipping",
        );
        this.noteButton = this.querySelector(
          ".cart-drawer-toolbar__note-button",
        );
        this.shippingButton = this.querySelector(
          ".cart-drawer-toolbar__shipping-button",
        );
        this.couponButton = this.querySelector(
          ".cart-drawer-toolbar__coupon-button",
        );
        this.expand = this.querySelector(".cart-drawer-toolbar__expand");
        this.cancelButtons = Array.from(
          this.querySelectorAll("[data-toolbar-cancel]"),
        );

        this.triggers.forEach((trigger) =>
          trigger.addEventListener("click", this.onTriggerClick),
        );
        this.cancelButtons.forEach((button) =>
          button.addEventListener("click", this.onCancelClick),
        );

        this.updateState();
      }

      disconnectedCallback() {
        this.triggers.forEach((trigger) =>
          trigger.removeEventListener("click", this.onTriggerClick),
        );
        this.cancelButtons.forEach((button) =>
          button.removeEventListener("click", this.onCancelClick),
        );
      }

      onTriggerClick(event) {
        const trigger = event.currentTarget;
        const section = trigger.dataset.toolbarTrigger;
        this.setActiveSection(section);
      }

      onCancelClick() {
        this.setActiveSection(null);
      }

      setActiveSection(section) {
        const next = this.activeSection === section ? null : section;
        this.activeSection = next;
        this.updateState();
      }

      updateState() {
        const isNote = this.activeSection === "note";
        const isShipping = this.activeSection === "shipping";
        const isCoupon = this.activeSection === "coupon";

        this.classList.toggle("is-note", isNote);
        this.classList.toggle("is-shipping", isShipping);
        this.classList.toggle("is-coupon", isCoupon);

        if (this.noteWrap) {
          this.noteWrap.classList.toggle("opacity-0", isShipping);
          this.noteWrap.classList.toggle("-translate-x-full", isShipping);
          this.noteWrap.classList.toggle("translate-x-0", !isShipping);
        }
        if (this.couponWrap) {
          this.couponWrap.classList.toggle("opacity-0", isShipping);
          this.couponWrap.classList.toggle("translate-x-full", isShipping);
          this.couponWrap.classList.toggle("translate-x-0", !isShipping);
        }
        if (this.shippingWrap) {
          this.shippingWrap.classList.toggle("w-full", isShipping);
          this.shippingWrap.classList.toggle("w-auto", !isShipping);
        }
        if (this.shippingButton) {
          this.shippingButton.classList.toggle("justify-center", isShipping);
        }
        if (this.expand) {
          this.expand.classList.toggle("grid-rows-[1fr]", isNote || isCoupon);
        }
        if (this.shippingButton) {
          this.shippingButton.classList.toggle("hidden", isShipping);
        }
        if (this.noteButton) {
          this.noteButton.classList.toggle("hidden", isShipping);
        }
        if (this.couponButton) {
          this.couponButton.classList.toggle("hidden", isShipping);
        }
        if (this.noteLabel) {
          this.noteLabel.classList.toggle("hidden", isShipping);
        }
        if (this.couponLabel) {
          this.couponLabel.classList.toggle("hidden", isShipping);
        }

        if (this.notePanel) {
          this.notePanel.classList.toggle("hidden", !isNote);
        }
        if (this.couponPanel) {
          this.couponPanel.classList.toggle("hidden", !isCoupon);
        }
        if (this.shippingPanel) {
          this.shippingPanel.classList.toggle("hidden", !isShipping);
        }

        const setButtonOpacity = (button, active) => {
          if (!button) return;
          button.classList.toggle("opacity-100", active);
          button.classList.toggle("opacity-60", !active);
        };
        setButtonOpacity(this.noteButton, isNote);
        setButtonOpacity(this.shippingButton, isShipping);
        setButtonOpacity(this.couponButton, isCoupon);

        this.triggers.forEach((trigger) => {
          const section = trigger.dataset.toolbarTrigger;
          const isActive = section === this.activeSection;
          trigger.setAttribute("aria-expanded", isActive ? "true" : "false");
        });
      }
    },
  );
}

// Cart Note Component
if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.form = null;
        this.submitButton = null;
        this.textarea = null;
        this.stateNodes = [];
        this.resetTimer = null;
        this.liveRegion = null;
        this.lastValue = "";
        this.onSubmit = this.onSubmit.bind(this);
        this.onBlur = this.onBlur.bind(this);
      }

      connectedCallback() {
        this.form = this.querySelector("form");
        if (!this.form) return;

        this.submitButton = this.querySelector("[data-cart-note-submit]");
        this.textarea = this.form.querySelector('textarea[name="note"]');
        this.stateNodes = Array.from(
          this.querySelectorAll("[data-note-state]"),
        );
        this.liveRegion = this.querySelector("[data-note-live]");
        this.form.addEventListener("submit", this.onSubmit);
        if (!this.submitButton && this.textarea) {
          this.textarea.addEventListener("blur", this.onBlur);
        }
        this.setState("idle");
        if (this.textarea) {
          this.lastValue = this.textarea.value || "";
        }
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener("submit", this.onSubmit);
        }
        if (this.textarea) {
          this.textarea.removeEventListener("blur", this.onBlur);
        }
        if (this.resetTimer) {
          clearTimeout(this.resetTimer);
          this.resetTimer = null;
        }
      }

      onSubmit(event) {
        event.preventDefault();
        if (!this.form) return;
        const formData = new FormData(this.form);
        const note = formData.get("note") || "";
        this.submitNote(note);
      }

      onBlur() {
        if (!this.textarea) return;
        const note = this.textarea.value || "";
        if (note === this.lastValue) return;
        this.submitNote(note);
      }

      submitNote(note) {
        if (note === this.lastValue) return;
        this.setState("saving");

        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ note }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Cart update error");
            }
            return response.json();
          })
          .then(() => {
            this.lastValue = note;
            const message = this.dataset.noteSuccess || "Note saved";
            this.setState("saved");
          })
          .catch(() => {
            const message = this.dataset.noteError || "Failed to save note";
            this.setState("idle");
          })
          .finally(() => {});
      }

      setState(state) {
        const isSaving = state === "saving";
        if (this.submitButton) {
          this.submitButton.setAttribute("data-state", state);
          this.submitButton.toggleAttribute("disabled", isSaving);
          this.submitButton.setAttribute(
            "aria-busy",
            isSaving ? "true" : "false",
          );
        }

        this.stateNodes.forEach((node) => {
          const isActive = node.dataset.noteState === state;
          node.classList.toggle("hidden", !isActive);
        });
        if (this.liveRegion) {
          const message =
            state === "saving" ? "Saving" : state === "saved" ? "Saved" : "";
          this.liveRegion.textContent = message;
        }

        if (state === "saved") {
          if (this.resetTimer) clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => {
            this.setState("idle");
          }, 1500);
        }
      }
    },
  );
}

// Cart Coupon Component
if (!customElements.get("cart-coupon")) {
  customElements.define(
    "cart-coupon",
    class CartCoupon extends HTMLElement {
      constructor() {
        super();
        this.form = null;
        this.input = null;
        this.submitButton = null;
        this.errorText = null;
        this.removeButtons = [];
        this.sectionId = null;
        this.drawer = null;
        this.drawerSectionId = null;
        this.page = null;
        this.pageSectionId = null;
        this.onSubmit = this.onSubmit.bind(this);
        this.onInput = this.onInput.bind(this);
        this.onRemoveSingle = this.onRemoveSingle.bind(this);
        this.isLoading = false;
      }

      connectedCallback() {
        this.form = this.querySelector("form");
        this.input = this.querySelector("[data-coupon-input]");
        this.submitButton = this.querySelector("[data-coupon-submit]");
        this.errorText = this.querySelector("[data-coupon-error]");
        this.removeButtons = Array.from(
          this.querySelectorAll("[data-coupon-remove-code]"),
        );
        this.sectionId = this.dataset.sectionId || "";
        this.drawer = document.getElementById("Cart-Drawer");
        this.drawerSectionId = this.drawer?.dataset?.sectionId || null;
        this.page = document.getElementById("Cart-Page");
        this.pageSectionId = this.page?.dataset?.sectionId || null;

        if (this.form) {
          this.form.addEventListener("submit", this.onSubmit);
        }
        if (this.input) {
          this.input.addEventListener("input", this.onInput);
        }
        this.removeButtons.forEach((button) => {
          button.addEventListener("click", this.onRemoveSingle);
        });
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener("submit", this.onSubmit);
        }
        if (this.input) {
          this.input.removeEventListener("input", this.onInput);
        }
        this.removeButtons.forEach((button) => {
          button.removeEventListener("click", this.onRemoveSingle);
        });
      }

      onSubmit(event) {
        event.preventDefault();
        if (!this.input || this.isLoading) return;

        const code = String(this.input.value || "").trim();
        if (!code) {
          this.setError(
            this.dataset.couponEmpty || "Please enter a coupon code.",
          );
          return;
        }

        this.startLoading();
        this.setError("");

        this.applyAndRender(code)
          .then(() => {
            if (this.input) this.input.value = "";
          })
          .catch((error) => {
            this.setError(
              error?.message || this.dataset.couponError || "Invalid code",
            );
          })
          .finally(() => {
            this.endLoading();
          });
      }

      onInput() {
        this.setError("");
      }

      onRemoveSingle(event) {
        const codeToRemove = event.currentTarget.dataset.couponRemoveCode;
        if (!codeToRemove || this.isLoading) return;

        this.startLoading();
        this.setError("");

        this.removeSingleCode(codeToRemove)
          .catch((error) => {
            this.setError(
              error?.message || "Failed to remove code",
            );
          })
          .finally(() => {
            this.endLoading();
          });
      }

      async removeSingleCode(codeToRemove) {
        // 1. Fetch current cart to get all applied codes
        const cart = await fetch("/cart.js", {
          headers: { Accept: "application/json" },
        }).then((r) => {
          if (!r.ok) throw new Error("Cart fetch error");
          return r.json();
        });

        const remaining = (cart.discount_codes || [])
          .filter((d) => d.applicable && d.code !== codeToRemove)
          .map((d) => d.code);

        // 2. Clear all codes
        await this.postDiscount("");

        // 3. Re-apply remaining codes one by one
        for (const code of remaining) {
          await this.postDiscount(code);
        }

        // 4. Fetch fresh sections and render
        await this.fetchAndRenderSections();
      }

      /** POST a discount code without fetching sections */
      async postDiscount(discount) {
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ discount }),
        });
        if (!response.ok) throw new Error("Cart update error");
        const data = await response.json();
        if (data.error) throw new Error(data.error);
        return data;
      }

      /** Apply a discount code and render updated sections */
      async applyAndRender(discount) {
        const sections = this.getSectionsToRender();
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            discount,
            sections: sections.map((s) => s.section),
            sections_url: window.location.pathname,
          }),
        });
        if (!response.ok) throw new Error("Cart update error");
        const data = await response.json();
        if (data.error) throw new Error(data.error);

        if (Array.isArray(data.discount_codes)) {
          const invalidCodes = data.discount_codes
            .filter((item) => item && item.applicable === false)
            .map((item) => item.code);
          if (invalidCodes.length) {
            const text = invalidCodes.join(", ");
            if (this.dataset.couponInvalid) {
              throw new Error(
                this.dataset.couponInvalid.replace("[code]", text),
              );
            }
            throw new Error(`Invalid code: ${text}`);
          }
        }

        if (data.sections) {
          this.renderSections(data.sections);
        }
        return data;
      }

      /** Fetch sections HTML from cart without changing discount */
      async fetchAndRenderSections() {
        const sections = this.getSectionsToRender();
        const response = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            sections: sections.map((s) => s.section),
            sections_url: window.location.pathname,
          }),
        });
        if (!response.ok) throw new Error("Cart update error");
        const data = await response.json();
        if (data.sections) {
          this.renderSections(data.sections);
        }
        return data;
      }

      getSectionsToRender() {
        const sections = [];
        if (this.drawerSectionId) {
          sections.push({
            id: "Cart-Drawer",
            section: this.drawerSectionId,
            selector: "[data-cart-drawer-content]",
          });
        }
        if (this.pageSectionId) {
          sections.push({
            id: "Cart-Page",
            section: this.pageSectionId,
            selector: "[data-cart-page-content]",
          });
        }
        if (!this.drawerSectionId && !this.pageSectionId && this.sectionId) {
          sections.push({
            id: "Cart-Drawer",
            section: this.sectionId,
            selector: "[data-cart-drawer-content]",
          });
        }
        return sections;
      }

      renderSections(sections = {}) {
        this.getSectionsToRender().forEach((section) => {
          const html = sections[section.section];
          if (!html) return;
          const container = document.getElementById(section.id);
          if (!container) return;
          const parsed = new DOMParser().parseFromString(html, "text/html");
          if (section.id === "Cart-Drawer") {
            const contentTarget = container.querySelector(
              "[data-cart-drawer-content]",
            );
            const summaryTarget = container.querySelector(
              "[data-cart-drawer-summary]",
            );
            const contentSource = parsed.querySelector(section.selector);
            const summarySource = parsed.querySelector(
              "[data-cart-drawer-summary]",
            );
            if (contentTarget && contentSource) {
              contentTarget.innerHTML = contentSource.innerHTML;
              this.refreshLazyImages(contentTarget);
            }
            if (summaryTarget && summarySource) {
              summaryTarget.innerHTML = summarySource.innerHTML;
              summaryTarget.className = summarySource.className;
            }
            return;
          }
          if (section.id === "Cart-Page") {
            const contentTarget = container.querySelector(
              "[data-cart-page-content]",
            );
            const contentSource = parsed.querySelector(section.selector);
            if (contentTarget && contentSource) {
              contentTarget.innerHTML = contentSource.innerHTML;
              this.refreshLazyImages(contentTarget);
            }
            return;
          }
        });
      }

      refreshLazyImages(target) {
        if (!target) return;
        if (
          !window.webvista ||
          typeof window.webvista.initLazyImageAnimation !== "function"
        )
          return;
        window.webvista.initLazyImageAnimation(target);
      }

      startLoading() {
        this.isLoading = true;
        if (this.input) this.input.setAttribute("disabled", "disabled");
        if (this.submitButton) {
          this.submitButton.setAttribute("disabled", "disabled");
          this.submitButton.setAttribute("aria-busy", "true");
          this.setButtonState("loading");
        }
        this.removeButtons.forEach((button) => {
          button.setAttribute("disabled", "disabled");
          button.classList.add("opacity-50", "pointer-events-none");
        });
      }

      endLoading() {
        this.isLoading = false;
        if (this.input) this.input.removeAttribute("disabled");
        if (this.submitButton) {
          this.submitButton.removeAttribute("disabled");
          this.submitButton.removeAttribute("aria-busy");
          this.setButtonState("idle");
        }
        this.removeButtons.forEach((button) => {
          button.removeAttribute("disabled");
          button.classList.remove("opacity-50", "pointer-events-none");
        });
      }

      setButtonState(state) {
        if (!this.submitButton) return;
        const states = Array.from(
          this.submitButton.querySelectorAll("[data-coupon-state]"),
        );
        if (!states.length) return;
        states.forEach((node) => {
          const isActive = node.dataset.couponState === state;
          node.classList.toggle("hidden", !isActive);
        });
      }

      setError(message) {
        if (!this.errorText) return;
        if (!message) {
          this.errorText.textContent = "";
          this.errorText.classList.add("hidden");
          return;
        }
        this.errorText.textContent = message;
        this.errorText.classList.remove("hidden");
      }
    },
  );
}

if (!customElements.get("cart-shipping")) {
  customElements.define(
    "cart-shipping",
    class CartShipping extends HTMLElement {
      constructor() {
        super();
        this.form = null;
        this.country = null;
        this.province = null;
        this.zip = null;
        this.submitButton = null;
        this.errorText = null;
        this.results = null;
        this.stateNodes = [];
        this.resetTimer = null;
        this.onSubmit = this.onSubmit.bind(this);
        this.onInput = this.onInput.bind(this);
      }

      connectedCallback() {
        this.form = this.querySelector("[data-shipping-form]");
        if (!this.form) return;

        this.country = this.form.querySelector('[name="country"]');
        this.province = this.form.querySelector('[name="province"]');
        this.zip = this.form.querySelector("[data-shipping-zip]");
        this.submitButton = this.form.querySelector("[data-shipping-submit]");
        this.errorText = this.form.querySelector("[data-shipping-error]");
        this.results = this.form.querySelector("[data-shipping-results]");
        this.stateNodes = Array.from(
          this.form.querySelectorAll("[data-shipping-state]"),
        );

        this.form.addEventListener("submit", this.onSubmit);
        [this.country, this.province, this.zip].forEach((field) => {
          if (field) field.addEventListener("input", this.onInput);
        });
        this.setState("idle");
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener("submit", this.onSubmit);
        }
        [this.country, this.province, this.zip].forEach((field) => {
          if (field) field.removeEventListener("input", this.onInput);
        });
        if (this.resetTimer) {
          clearTimeout(this.resetTimer);
          this.resetTimer = null;
        }
      }

      onSubmit(event) {
        event.preventDefault();
        if (!this.form || !this.country || !this.zip) return;

        const country = this.country.value || "";
        const province = this.province ? this.province.value : "";
        const zip = this.zip.value || "";
        if (!country || !zip) {
          const message =
            this.dataset.shippingErrorRequired ||
            "Please enter a country and postal code.";
          this.setError(message);
          return;
        }

        this.setError("");
        this.setResults([]);
        this.setState("saving");

        const params = new URLSearchParams();
        params.set("shipping_address[country]", country);
        if (province) params.set("shipping_address[province]", province);
        params.set("shipping_address[zip]", zip);

        fetch(`/cart/shipping_rates.json?${params.toString()}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to fetch rates");
            }
            return response.json();
          })
          .then((data) => {
            const rates = Array.isArray(data.shipping_rates)
              ? data.shipping_rates
              : [];
            if (!rates.length) {
              const message =
                this.dataset.shippingErrorEmpty || "No shipping rates found.";
              this.setError(message);
              this.setState("idle");
              return;
            }
            this.setResults(rates);
            this.setState("saved");
          })
          .catch((error) => {
            const message =
              error && error.message
                ? error.message
                : this.dataset.shippingErrorFetch || "Failed to fetch rates";
            this.setError(message);
            this.setResults([]);
            this.setState("idle");
          })
          .finally(() => {});
      }

      onInput() {
        this.setError("");
        this.setResults([]);
        this.setState("idle");
      }

      setError(message) {
        if (!this.errorText) return;
        if (!message) {
          this.errorText.textContent = "";
          this.errorText.classList.add("hidden");
          return;
        }
        this.errorText.textContent = message;
        this.errorText.classList.remove("hidden");
      }

      setResults(rates) {
        if (!this.results) return;
        this.results.innerHTML = "";
        if (!rates || !rates.length) {
          this.results.classList.add("hidden");
          return;
        }
        const fragment = document.createDocumentFragment();
        rates.forEach((rate) => {
          const row = document.createElement("div");
          row.className =
            "cart-drawer-toolbar__shipping-rate flex items-center justify-between text-xs text-foreground/70";
          const name = document.createElement("span");
          name.className = "cart-drawer-toolbar__shipping-rate-name";
          const defaultLabel = this.dataset.shippingRateLabel || "Shipping";
          name.textContent = rate.name || defaultLabel;
          const price = document.createElement("span");
          price.className =
            "cart-drawer-toolbar__shipping-rate-price font-medium";
          price.innerHTML = window.webvista?.formatPriceMarkup && Number.isFinite(Number.parseFloat(rate.price))
            ? window.webvista.formatPriceMarkup(Math.round(Number.parseFloat(rate.price) * 100), rate.currency || window.Shopify?.currency?.active)
            : "";
          row.appendChild(name);
          row.appendChild(price);
          fragment.appendChild(row);
        });
        this.results.appendChild(fragment);
        this.results.classList.remove("hidden");
      }

      formatPrice(rate) {
        if (!rate) return "";
        const raw = rate.price;
        const currency = rate.currency;
        if (raw != null) {
          const amount = Number.parseFloat(raw);
          if (!Number.isNaN(amount) && window.webvista?.formatPriceAmount) {
            const cents = Math.round(amount * 100);
            const formatted = window.webvista.formatPriceAmount(
              cents,
              currency || window.Shopify?.currency?.active,
            );
            if (formatted) return formatted;
          }
          if (currency) return `${raw} ${currency}`;
        }
        return raw || "";
      }

      startLoading() {
        if (this.submitButton) {
          this.submitButton.setAttribute("disabled", "disabled");
          this.submitButton.setAttribute("aria-busy", "true");
        }
      }

      endLoading() {
        if (this.submitButton) {
          this.submitButton.removeAttribute("disabled");
          this.submitButton.removeAttribute("aria-busy");
        }
      }

      setState(state) {
        if (!this.submitButton) return;
        this.submitButton.setAttribute("data-state", state);
        const isSaving = state === "saving";
        this.submitButton.toggleAttribute("disabled", isSaving);
        this.submitButton.setAttribute(
          "aria-busy",
          isSaving ? "true" : "false",
        );

        this.stateNodes.forEach((node) => {
          const isActive = node.dataset.shippingState === state;
          node.classList.toggle("hidden", !isActive);
        });

        if (state === "saved") {
          if (this.resetTimer) clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => {
            this.setState("idle");
          }, 1500);
        }
      }
    },
  );
}
